<template>
    <div id="app">
        <div class="navbar">
            <span>
                <Logo />
            </span>
            <span class="label">
                Push Notifications
            </span>
            <img @click="showInfo" src="/info.svg" width="26" class="info" title="Hoe werkt deze tool?">
            <img v-if="isAuthenticated" @click="logout" src="/logout.svg" width="26" class="info">
        </div>
        <div class="content">
            <div v-if="displayInfo">
                <Info @hideinfo="hideInfo" />
            </div>
            <div v-if="!displayInfo">
                <PusherHome />
            </div>
        </div>
    </div>
</template>

<script>
    import PusherHome from './components/PusherHome'
    import Logo from './components/Logo'
    import Info from './components/Info'

    export default {
        name: 'app',
        components: {
            PusherHome,
            Logo,
            Info,
        },
        data() {
            return {
                displayInfo: false
            }
        },
        computed: {
            isAuthenticated() { return this.$api.isAuthenticated }
        },
        methods: {
            showInfo() {
                this.displayInfo = true
            },
            hideInfo() {
                this.displayInfo = false
            },
            logout() {
                this.$api.logout()
            }
        }
    }
</script>

<style>
    body {
        margin: 0;
        padding: 0;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    #app {

    }
    .navbar {
        background-color: #212529;
        color: white;
        padding: 12px;
        font-size: 20px;
        height:40px;
        display: flex;
    }
    .navbar span {
        float:left;
    }
    .navbar img {
        padding-left: 10px;
    }
    .label {
        margin-left: 6px;
        margin-top: 9px;
        flex-grow: 1;
    }
    .content {
        padding: 36px;
    }
    .info {
        cursor: pointer;
    }
</style>
